module.exports = __webpack_public_path__ + "img/p4g_icon.8eeb8b5e.svg";